export enum OrigemEnum {
    Cliente = 1,
    Produto = 4,
    Venda = 6,
    GrupoRegrasFiscais = 17,
    Protesto = 31,
    Separacao = 32,
}

export enum AcaoEnum {
    Insercao = 1,
    Alteracao = 2,
    Exclusao = 3,
}

export enum LogPeriodo {
    TODO_PERIODO = 1,
    TRES_DIAS = 2,
    UMA_SEMANA = 3,
    DUAS_SEMANAS = 4,
    UM_MES = 5,
    DOIS_MESES = 6,
    TRES_MESES = 7,
    SEIS_MESES = 8,
    UM_ANO = 9,
}
